<template>
  <div class="chart">
    <highcharts :options="chartOptions" :updateArgs="updateArgs" ref="myChart"></highcharts>
  </div>
</template>

<script>
var moment = require("moment-timezone");

export default {
  name: "UserEquity",
  props: ["data"],
  data() {
    return {
      chartPl: [],
      chartDD: [],
      chartRU: [],
      moment: moment,
      updateArgs: [true, true, { duration: 300 }],
      chartOptions: {
        chart: {
          backgroundColor: "#28303D",
          marginRight: 50,
          height: 370
        },
        title: {
          text: ""
        },
        xAxis: [
          {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: "transparent",
            minorTickLength: 0,
            tickLength: 0,
            gridLineWidth: 1,
            gridLineColor: "rgba(128, 143, 156, 0.1)",
            //type: "datetime",
            labels: {
              align: "left",
              x: -10,
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              }
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                enabled: true,
                padding: 3,
                formatter: function(value) {
                  //return moment(new Date(value)).calendar();
                  return value.toFixed(0);
                },
                //    format: "{value:%H:%M:%S}",
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif"
                }
              }
            }
          }
        ],
        yAxis: [
          {
             plotLines: [{
            color: 'rgba(128, 143, 156, 0.6)',
            width: 1,
            value: 0,
            dashStyle: 'ShortDash'
        }],
            title: "",
            gridLineWidth: 0,
            opposite: true,
            resize: {
              enabled: false
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                adjustToOffset: true, // New param
                enabled: true,
                padding: 3,
                offset: -60,
                zIndex: 30,
                formatter: function(value) {
                  return (Math.ceil(value / 0.25) * 0.25).toFixed(2);
                },
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif",
                  zIndex: 30
                }
              }
            },
            offset: 100,
            labels: {
              distance: 0,
              align: "left",
              format: "{value:.2f}",
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              },
              y: 6,
              x: 18
            }
          }
        ],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
                color: "#ffffff",
                textOutline: 0
              },
              formatter: function() {
                return null;
              },
              
            },
            animations: false
            //cursor: 'pointer',
          },
          flags: {
            fillColor: "transparent",
            color: "transparent",
            //y: 0,
            //x: 0,
            //yAxis: 50,
            style: { fontSize: "11px", color: "white" }
          },
          line: {
            color: "#808F9C",
            marker: {
              enabled: false
            }
          },
          ohlc: {
            color: "#808F9C",
            lineWidth: 1
          },
          scatter: {
            color: "#ffffff",
            lineWidth: 20,
            marker: {
              radius: 4,
              symbol: "circle"
            }
          },
          column: {
            dataGrouping: {
              enabled: false
            }
          },
          bubble: {
            tooltip: {
              shared: false,
              pointFormat:
                '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
            },
            minSize: 10,
            maxSize: 20,
            dataLabels: {
              inside: true,
              enabled: true,
              format: "{point.value}"
            },
            cursor: "pointer"
          }
        },
        tooltip: {
          //backgroundColor: "#28303D",
          backgroundColor: 'rgba(40, 48, 61,0.7)',
          style: {
            fontFamily: "Roboto, sans-serif",
            color: "#808F9C",
            fontSize: "11px",
            fontWeight: "light"
          },
          shape: "square",
          headerShape: "callout",
          borderWidth: 1,
          shadow: false,
          
          formatter: function() {
            var color = "#E62163"
            if(this.y > 0) color = "#79C04D"
            var plcolor = "#E62163"
            if(this.point.tradePL > 0) plcolor = "#79C04D"
            return (
              "Date: <span style='color: white'> "+moment.tz(this.point.openTimestamp, this.point.timezone).format("YYYY-MM-DD H:mm:ss")+"</span><br> Trade #: <span style='color: white'>" +
              this.x +
              "</span> <br> Equity: <span style='color: "+color+" !important'>$" +
              this.y.toFixed(2) + "</span><br> PL: <span style='color: "+plcolor+" !important'>$" +
              this.point.tradePL.toFixed(2) + "</span><br> RU: <span style='color: #79C04D !important'>$" +
              this.point.tradeRU.toFixed(2) + "</span><br> DD: <span style='color: #E62163 !important'>$" +
              this.point.tradeDD.toFixed(2) + "</span>"
  
            );
          }
        },
        credits: { enabled: false },
        legend: { enabled: false },
        series: [
          {
            animation: true,
            enableMouseTracking: true,
            //data: this.$store.state.highchartsData,
            data: [],
            type: "line",
            cursor: "pointer",
              point: {
                events: {
                  click: (data) => {
                  this.routeToTrade(data)
                }
                /*
                  click: function() {
                    if(this.x !=0)
                    location.href =
                      "https://tradeinpool.com/trades/" + this.user + "/" +this.openTimestamp;
                  }
                  */
                }
              }
          },
          {
            animation: true,
            enableMouseTracking: false,
            //data: this.$store.state.highchartsData,
            color: "#E62163",
            //yAxis: 1,
            data: [],
            type: "line",
            lineWidth: 2,
            dashStyle: "Dot"
          },
          {
            animation: true,
            enableMouseTracking: false,
            //data: this.$store.state.highchartsData,
            color: "#79C04D",
            data: [],
            type: "line",
            lineWidth: 2,
            dashStyle: "Dot"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "flags"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter",
            color: "#28303D",
            marker: {
              radius: 1,
              symbol: "circle"
            }
          }
        ]
      }
    };
  },
  watch: {
    data: function() {
      this.equityData();
    }
  },
  methods: {
    routeToTrade(data) {
      return this.$router.push({ path: "/trades/" + data.point.user +"/"+ data.point.openTimestamp});
    },
    equityData() {
      this.chartPl = [{ x: 0, y: 0 }];
      this.chartDD = [{ x: 0, y: 0 }];
      this.chartRU = [{ x: 0, y: 0 }];
      var plSum = 0;
      this.data.forEach((trade, index) => {
        plSum += trade.ClosedProfitLoss;
        /*

        this.chartPl.push([trade.openTimestamp, plSum]);

        if (this.chartPl.length == 1) {
          this.chartDD.push([
            trade.openTimestamp,
            trade.FlatToFlatMaximumOpenPositionLoss
          ]);
          this.chartRU.push([
            trade.openTimestamp,
            trade.FlatToFlatMaximumOpenPositionProfit
          ]);
        } else {
          var prevPl = this.chartPl[this.chartPl.length - 2][1];
          
          this.chartDD.push([
            trade.openTimestamp,
            prevPl + trade.FlatToFlatMaximumOpenPositionLoss
          ]);

          this.chartRU.push([
            trade.openTimestamp,
            prevPl + trade.FlatToFlatMaximumOpenPositionProfit
          ]);
        }
  */

        this.chartPl.push({ 
          x: index + 1,
          y: plSum, 
          openTimestamp: trade.openTimestamp, 
          user: this.$route.params.name, 
          tradePL: trade.ClosedProfitLoss,
          tradeRU: trade.FlatToFlatMaximumOpenPositionProfit, 
          tradeDD: trade.FlatToFlatMaximumOpenPositionLoss,
          timezone: this.$store.getters.timezone
          });

        if (this.chartPl.length == 1) {
          this.chartDD.push({
            x: index + 1,
            y: trade.FlatToFlatMaximumOpenPositionLoss
          });
          this.chartRU.push({
            x: index + 1,
            y: trade.FlatToFlatMaximumOpenPositionProfit
          });
        } else {
          var prevPl = this.chartPl[this.chartPl.length - 2].y;

          this.chartDD.push({
            x: index + 1,
            y: prevPl + trade.FlatToFlatMaximumOpenPositionLoss
          });

          this.chartRU.push({
            x: index + 1,
            y: prevPl + trade.FlatToFlatMaximumOpenPositionProfit
          });
        }
      });
      this.chartOptions.series[0].data = this.chartPl;
      this.chartOptions.series[1].data = this.chartDD;
      this.chartOptions.series[2].data = this.chartRU;
    }
  }
};
</script>

<style scoped>
.chart {
  float: left;
  width: 100%;
  padding: 5px 0px 5px 5px;
  cursor: crosshair;
}
</style>


